import { useState } from "react";
import { selectCommunicationData } from "../../store";
import { useAppSelector } from "../../store/hooks";
import { FileItemType } from "../../types/communication/communicationDataType";
import FotoMultiSection from "../foto-multi-section/FotoMultiSection";
import EsempiDannoVeicolo from "./EsempiDannoVeicolo";
import { LiqPhotoTypeMapper, PhotoTypeEnum } from "../../types/commonTypes";

/* istanbul ignore next */
const FotoDannoVeicolo = () => {
    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData
    const [fotoDanniList, setFotoDanniList] = useState<FileItemType[]>(communication.fotoDanniList)
    return (
        <>
            <EsempiDannoVeicolo />
            <FotoMultiSection
                fileType={PhotoTypeEnum.DANNO_VEICOLO_DOCS}
                additionalBeInfo={{
                    liqDocumentType: LiqPhotoTypeMapper[PhotoTypeEnum.DANNO_VEICOLO_DOCS],
                    liqDescription: "FP - altro"
                }}
                files={fotoDanniList}
                setFiles={setFotoDanniList}
                arrayDbPropSync={"fotoDanniList"}
                textLabel={"Scatta foto"}
                titleImageDetail={"Foto danno"}
                minPhotoNumber={3}
            />
        </>
    )
}

export default FotoDannoVeicolo